export const buttons = [
  {
    id: 1,
    title: 'Вилоят',
    value: 'province',
  },
  {
    id: 2,
    title: 'Туманлар',
    value: 'region',
  },
  {
    id: 3,
    title: 'Гуруҳлар',
    value: 'group',
  },
  {
    id: 4,
    title: 'Ташкилотлар',
    value: 'organization',
  },
];

export const formProvinceData = {
  title: 'Вилоят қўшиш',
  data: [
    { type: 'text', label: 'Номи', name: 'title', value: '', size: 24 },
    { type: 'textarea', label: 'Изоҳ', name: 'desc', value: '', size: 24 },
  ],
};
export const formRegionData = {
  title: 'Туман қўшиш',

  data: [
    { type: 'text', label: 'Номи', name: 'title', value: '', size: 24 },
    { type: 'textarea', label: 'Изоҳ', name: 'desc', value: '', size: 24 },
    { type: 'select', label: 'Вилоят', name: 'province', value: '', size: 24 },
  ],
};
export const formgroupData = {
  title: 'Гуруҳ қўшиш',
  data: [
    { type: 'text', label: 'Номи', name: 'title', value: '', size: 24 },
    { type: 'textarea', label: 'Изоҳ', name: 'desc', value: '', size: 24 },
  ],
};

export const formOrganizationData = {
  title: 'Гуруҳ қўшиш',
  data: [
    { type: 'text', label: 'Номи', name: 'title', value: '', size: 24 },
    { type: 'textarea', label: 'Изоҳ', name: 'desc', value: '', size: 24 },
    { type: 'select', label: 'Гуруҳ', name: 'group', value: '', size: 24 },
  ],
};
